module.exports = __webpack_public_path__ + "img/logo-ooca.f181219d.svg";